import { FC, useState, useRef } from 'react';
import Icon, { iconOptions } from '../Icon';
import styles from './GroupActions.module.scss';
import cx from 'classnames';
import debounce from '../../utils/debounce';
import Button from './Button';

export interface FilterInputProps {
  showReset: boolean;
  handleReset: () => void;
  handleFilterInput: (param: React.ChangeEvent<HTMLInputElement>, type?: string) => void;
}

const FilterInput: FC<FilterInputProps> = ({ showReset, handleReset, handleFilterInput }) => {
  const [showFilter, setShowFilter] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const resetFilter = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    handleReset();
  };
  return (
    <div className={cx(styles.filterInput)}>
      {showReset && (
        <div className={styles.filterInput__resetButton}>
          <Button variant='rounded' theme='white' onClick={resetFilter}>
            Reset
          </Button>
        </div>
      )}
      <div
        className={cx(styles.filterInput__inputGroup, {
          [styles['filterInput__inputGroup--isOpen']]: showFilter,
        })}
      >
        <Button
          className={styles.filterInput__inputButton}
          onClick={() => {
            setShowFilter(!showFilter);
            showFilter ? inputRef.current?.blur() : inputRef.current?.focus();
          }}
          icon='filter'
          theme='primary'
        />
        <div className={cx(styles.filterInput__input)}>
          <input ref={inputRef} type='text' name='filter' onChange={debounce(handleFilterInput)} />
        </div>
      </div>
    </div>
  );
};

export default FilterInput;
